var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedoEditorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 3.25H13.1156L10.8737 1.00875L11.75 0.125L15.5 3.875L11.75 7.625L10.8737 6.74062L13.1137 4.5H5.5C4.50544 4.5 3.55161 4.89509 2.84835 5.59835C2.14509 6.30161 1.75 7.25544 1.75 8.25C1.75 9.24456 2.14509 10.1984 2.84835 10.9017C3.55161 11.6049 4.50544 12 5.5 12H10.5V13.25H5.5C4.17392 13.25 2.90215 12.7232 1.96447 11.7855C1.02678 10.8479 0.5 9.57608 0.5 8.25C0.5 6.92392 1.02678 5.65215 1.96447 4.71447C2.90215 3.77678 4.17392 3.25 5.5 3.25Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedoEditorIcon);
export default __webpack_public_path__ + "static/media/redo-editor-icon.1cc708fa1ef6dea4effc411bc584bae0.svg";
export { ForwardRef as ReactComponent };